import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createDiagramItem = (data) => ({
  type: ActionTypes.DIAGRAM_CREATE,
  payload: {
    data,
  },
});

export const updateDiagramItem = (id, data) => ({
  type: ActionTypes.DIAGRAM_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteDiagramItem = (id) => ({
  type: ActionTypes.DIAGRAM_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createDiagramItemRequested = (data) => ({
  type: ActionTypes.DIAGRAM_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createDiagramItemSucceeded = (diagram) => ({
  type: ActionTypes.DIAGRAM_CREATE_SUCCEEDED,
  payload: {
    diagram,
  },
});

export const createDiagramItemFailed = (error) => ({
  type: ActionTypes.DIAGRAM_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createDiagramItemReceived = (diagram) => ({
  type: ActionTypes.DIAGRAM_CREATE_RECEIVED,
  payload: {
    diagram,
  },
});

export const updateDiagramItemRequested = (id, data) => ({
  type: ActionTypes.DIAGRAM_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateDiagramItemSucceeded = (diagram) => ({
  type: ActionTypes.DIAGRAM_UPDATE_SUCCEEDED,
  payload: {
    diagram,
  },
});

export const updateDiagramItemFailed = (id, error) => ({
  type: ActionTypes.DIAGRAM_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateDiagramItemReceived = (diagram) => ({
  type: ActionTypes.DIAGRAM_UPDATE_RECEIVED,
  payload: {
    diagram,
  },
});

export const deleteDiagramItemRequested = (id) => ({
  type: ActionTypes.DIAGRAM_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteDiagramItemSucceeded = (diagram) => ({
  type: ActionTypes.DIAGRAM_DELETE_SUCCEEDED,
  payload: {
    diagram,
  },
});

export const deleteDiagramItemFailed = (id, error) => ({
  type: ActionTypes.DIAGRAM_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteDiagramItemReceived = (diagram) => ({
  type: ActionTypes.DIAGRAM_DELETE_RECEIVED,
  payload: {
    diagram,
  },
});
